import React, { useEffect, useState } from 'react';
import './Styles.css';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useGlobalContext } from '../../context/GlobalContext';
import { PresentationMode } from '../../Enums/PresentationMode';
import { formatMessage } from '../../Localization/formatMessage';
import Messages from '../../Localization/Messages';
import { ServiceClient } from '../../Services/ServiceClient';
import { employerModalType } from './EmployerModalType';
import RemoveAgent from './Modals/RemoveAgent';
import EmployerInfo from './Modals/EmployerInfo';
import EmployerHeader from './EmployerHeader/EmployerHeader';
import LoaderComponent from '../../Elements/ids/Loader';
import ErrorMode from './ErrorMode';
import ConnectedAgents from './ConnectedAgents';
import ConnectedTeamsModal from './Modals/ConnectedTeams/ConnectedTeams';
import { mapGetEmployerResponse } from './Functions';
import EmployerAddress from './Modals/EmployerAddress';
import BreadcrumbRow from '../../Elements/Breadcrumbs';

const EmployerPage = ({ presentationMode }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { addBreadcrumbs } = useGlobalContext();
  const { employerId } = useParams();
  const [pageMode, setPageMode] = useState(presentationMode);
  const [employer, setEmployer] = useState(location.state ?? {});
  const [openedModal, setOpenedModal] = useState(
    presentationMode === PresentationMode.Add ? employerModalType.EmployerInfo : employerModalType.None
  );
  const [modalAgent, setModalAgent] = useState({});
  const [errorData, setErrorData] = useState({});

  useEffect(() => {
    if (pageMode === PresentationMode.Add) {
      addBreadcrumbs([
        {
          trackingName: 'employerPage',
          link: `/employer/add/`,
          title: formatMessage(Messages.breadcrumb_employerPage),
        },
      ]);
    } else {
      addBreadcrumbs([
        {
          trackingName: 'employerPage',
          link: `/employer/view/${employerId}`,
          title: formatMessage(Messages.breadcrumb_employerPage),
        },
      ]);
    }

    if (pageMode === PresentationMode.Add) return;

    ServiceClient.getEmployer(
      employerId,
      result => {
        setEmployer(mapGetEmployerResponse(result));
      },
      (errorMessage, errorData) => {
        setErrorData(errorData);
        setPageMode(PresentationMode.Error);
      }
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="employerPage-container">
      {pageMode === PresentationMode.Loading ? (
        <LoaderComponent />
      ) : pageMode === PresentationMode.Error ? (
        <ErrorMode
          errorData={errorData}
          createNewTeam={() => {
            setEmployer({});
            setPageMode(PresentationMode.Add);
            setOpenedModal(employerModalType.EmployerInfo);
          }}
        />
      ) : (
        <>
          <BreadcrumbRow />
          <EmployerHeader employer={employer} setOpenedModal={setOpenedModal} pageMode={pageMode} />

          <div className="employerPage-tableContainer">
            <ConnectedAgents agents={employer?.agents} setOpenedModal={setOpenedModal} setModalAgent={setModalAgent} />
          </div>
          {openedModal === employerModalType.RemoveAgent ? (
            <RemoveAgent
              employer={employer}
              employerAgent={modalAgent}
              setEmployer={setEmployer}
              closeView={() => {
                setOpenedModal(employerModalType.None);
              }}
            />
          ) : openedModal === employerModalType.EmployerInfo ? (
            <EmployerInfo
              employer={employer}
              closeView={() => {
                setOpenedModal(employerModalType.None);
              }}
              setEmployer={setEmployer}
              createNewEmployer={newEmployer => {
                setEmployer(newEmployer);
                setPageMode(PresentationMode.View);
                navigate(`/employer/view/${newEmployer.id}`);
              }}
            />
          ) : openedModal === employerModalType.ConnectedTeams ? (
            <ConnectedTeamsModal
              employer={employer}
              setEmployer={setEmployer}
              closeView={() => {
                setOpenedModal(employerModalType.None);
              }}
            />
          ) : openedModal === employerModalType.AddressInfo ? (
            <EmployerAddress
              employer={employer}
              setEmployer={setEmployer}
              closeView={() => {
                setOpenedModal(employerModalType.None);
              }}
            />
          ) : null}
        </>
      )}
    </div>
  );
};

export default EmployerPage;
